import type { CommandBody } from '../CrossOriginMessage';
import type { EntityChanged } from './shared/entity-changed';

/**
 * Indicates that the entity of reference has deleted.
 */
export class EntityDeletedCommandBody implements CommandBody {
  /**
   * Deleted entity.
   */
  entityChanged: EntityChanged;
}
